<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 31.012 30.509"
        style="fill: currentColor"
    >
        <g id="export" transform="translate(0 0)">
            <path
                id="Path_86"
                data-name="Path 86"
                d="M14.214,22.665,0,16.15v3.037a.644.644,0,0,0,.389.592L14.214,25.79Z"
                transform="translate(0 4.718)"
            />
            <path
                id="Path_87"
                data-name="Path 87"
                d="M13,22.665v3.126L26.825,19.78a.647.647,0,0,0,.389-.593V16.15Z"
                transform="translate(3.798 4.718)"
            />
            <path
                id="Path_88"
                data-name="Path 88"
                d="M15.368,18.09h-3.23a1.617,1.617,0,0,1-1.615-1.615V8.722H6.969a.97.97,0,0,1-.685-1.654L13.068.284a.969.969,0,0,1,1.371,0l6.784,6.784a.97.97,0,0,1-.685,1.654H16.983v7.753A1.617,1.617,0,0,1,15.368,18.09Z"
                transform="translate(29.261 18.09) rotate(180)"
            />
            <path
                id="Path_89"
                data-name="Path 89"
                d="M22.205,11.681c-1.284,1.264-5.513,5.254-6.7,5.282-1.394.043-5.053-3.775-6.748-5.282L0,15.5l15.506,7.107L31.012,15.5Z"
                transform="translate(0 3.232)"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-export",
});
</script>
